import { Service } from '@roc/feature-app-core';

const url = {
  GET_SIGNING_INFO: '/api/v1/loan/public/bankInfo/getSigningInfo',
  GENERATE_DOCUMENT: '/api/v1/loan/public/bankInfo/generateVerifyBankInformationDocument',
};

export class VerifyBankInformationService extends Service {
  getSigningInfo(token: string) {
    return this.get(url.GET_SIGNING_INFO, { token });
  }

  generateVerifyBankInformationDocument(request: any) {
    return this.post(url.GENERATE_DOCUMENT, request, {
      'Content-Type': 'application/json',
    });
  }
}
